import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BarCharts } from "../../../../Constant";
import Chart from "react-apexcharts";
import { BAR_CHART } from "../../../../Data/Charts/ApexChart";

const BarChart = () => {
  return (
    <Col sm="12" xl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={BarCharts} />
        <CardBody>
          <div id="basic-bar">
            <Chart options={BAR_CHART} series={BAR_CHART.series} type="bar" height={350} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BarChart;
